import { MutationTree } from 'vuex';
import { IDomState } from '../../interfaces';

export const mutations: MutationTree<IDomState> = {
  SET_WINDOW_WIDTH(state, value) {
    state.windowWidth = value;
  },
};
